module.exports = __webpack_public_path__ + "static/media/ca_club_white.e3a1814a.png";